<template>
    <text-input
      :label="label"
      :prop="prop"
      :required="required"
      type="number"
      :decimals="decimals"
      v-model="form"
      :pattern="pattern"
      :size="size"
      align-input="right"
      :min="min"
      :max="max"
      :prefix="prefix"
      :suffix="suffix"
      :is-prefix-icon="isPrefixIcon"
      :is-suffix-icon="isSuffixIcon"
      @input="v = parseFloat($event)"
     :disabled="disabled"
     :placeholder="placeholder"
     :no-form="noForm"
     @change="updated">
   </text-input>
</template>

<script>

import NumberMixins from '@/mixins/NumberMixins'

export default {
  name: 'float-input',

  mixins: [NumberMixins],

  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
//      type: Number,
      required: true
    },
    prop: {
      type: String,
      default: null
    },
    decimals: {
      type: Number,
      default: 2
    },
    pattern: {
      type: String,
      default: null
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: Number.MAX_SAFE_INTEGER
    },
    size: {
      type: String,
      default: 'default'
    },
    prefix: {
      type: String,
      default: null
    },
    suffix: {
      type: String,
      default: null
    },
    isPrefixIcon: {
      type: Boolean,
      default: false
    },
    isSuffixIcon: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: null
    },
    helpText: {
      type: String,
      default: null
    },
    noForm: {
      type: Boolean,
      default: false
    }
  },



  watch: {

    value: function (val) {
      this.form = val
    }

  },


  methods: {
    updated (value) {
      this.$emit('input', Number(value))
      this.$emit('change', Number(value))
    }
  },

  data () {
    return {
      form: this.value
    }
  }

}
</script>

<style scoped>
input {
  float: right;
  clear: both;
}
</style>



// WEBPACK FOOTER //
// FloatInput.vue?3d8532e5